// extracted by mini-css-extract-plugin
export default {"cta":"cJ-z","disabled":"dJ-z"};